import React, { useState } from 'react';
import SEO from '../../components/ui/SEO';
import { ChevronDown, ChevronUp, Clock, AlertCircle, Mail } from 'lucide-react';
export default function Cancellation() {
  const [openSections, setOpenSections] = useState({
    standard: true,
    court: true,
    howToCancel: true
  });
  const toggleSection = section => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  return <main className="min-h-screen bg-white" data-id="element-687" data-mp="2nfs69hq4p7fp">
      <SEO title="Cancellation Policy | Assessments and Court Dates" description="Notice periods and charges for cancelling or rescheduling a psychiatric assessment or reserved court attendance. Contact us to change a booking." path="/policies/cancellation" keywords={['psychiatric assessment cancellation policy', 'expert witness court attendance terms']} imageAlt="Cancellation and rescheduling policy for assessments and court attendance" data-id="element-688" data-mp="2jdyc7safv1oi" />
      {/* Hero Section */}
      <section className="bg-primary text-white py-16 pt-24 md:pt-28" data-id="element-689" data-mp="esh0remx8o7q">
        <div className="container mx-auto px-4" data-id="element-690" data-mp="jragzetletbl">
          <div className="flex items-center justify-center mb-4" data-id="element-691" data-mp="ju6ckwhyx5wv">
            <Clock className="h-12 w-12 mr-4" data-id="element-692" data-mp="oshordvqjsi9" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold" data-id="element-693" data-mp="tq9ec18wr2ja">
              Cancellation and Rescheduling Policy
            </h1>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-16" data-id="element-694" data-mp="112ff15jkaxi">
        <div className="container mx-auto px-4" data-id="element-695" data-mp="123stca159ie">
          <div className="max-w-3xl mx-auto" data-id="element-696" data-mp="60ymxadg6kht">
            <p className="text-slate-dark text-lg mb-8" data-id="element-697" data-mp="5z42rya02wes">
              This policy is designed to ensure the efficient management of our
              professional commitments and to provide clear guidelines for all
              parties.
            </p>
            <div className="space-y-4 mb-8" data-id="element-698" data-mp="3efytyghfqsd1">
              {/* Standard Appointments Section */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-699" data-mp="36fj05vm2q9nd">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.standard ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('standard')} data-id="element-700" data-mp="31gpp09u9euqd">
                  <div className="flex items-center" data-id="element-701" data-mp="3b7asaakvonfm">
                    <Clock className="h-5 w-5 mr-2" data-id="element-702" data-mp="2ng567docgywv" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-703" data-mp="2nirni511essa">
                      Standard Appointments and Assessments
                    </h2>
                  </div>
                  {openSections.standard ? <ChevronUp className="h-5 w-5" data-id="element-704" data-mp="2sgb1d3ttp3jp" /> : <ChevronDown className="h-5 w-5" data-id="element-705" data-mp="2sie0qegv8913" />}
                </button>
                {openSections.standard && <div className="p-6 bg-white" data-id="element-706" data-mp="7qlkymdh19ow">
                    <p className="text-slate-dark mb-4" data-id="element-707" data-mp="7rwpioeqqlh2">
                      Due to the significant time allocated for each assessment,
                      including preparation and report writing, our cancellation
                      policy is strictly enforced to maintain the quality of
                      service for all clients.
                    </p>
                    <ul className="space-y-3 text-slate-dark" data-id="element-708" data-mp="ab05avxf2nle">
                      <li className="flex items-start" data-id="element-709" data-mp="y02rmh2zx4m8">
                        <AlertCircle className="h-5 w-5 text-primary mr-2 mt-1" data-id="element-710" data-mp="y0kxm5fgmx7c" />
                        <div data-id="element-711" data-mp="12ye4z1si1x97">
                          <strong data-id="element-712" data-mp="130qkz9ep5xjm">More than 72 hours' notice:</strong> There
                          will be no charge for appointments cancelled with more
                          than 72 hours' notice.
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-713" data-mp="1gxvnx0j46gan">
                        <AlertCircle className="h-5 w-5 text-primary mr-2 mt-1" data-id="element-714" data-mp="1lp5attda35iu" />
                        <div data-id="element-715" data-mp="1lr8c59jvsl2v">
                          <strong data-id="element-716" data-mp="3u6zmjbxwm98y">Less than 72 hours' notice:</strong> The
                          instructing party will be charged for all preparation
                          work already undertaken at our Hourly Rate, plus any
                          incurred travel time and expenses.
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-717" data-mp="3g8hzzhjqj2sm">
                        <AlertCircle className="h-5 w-5 text-primary mr-2 mt-1" data-id="element-718" data-mp="grtjyekizuqd" />
                        <div data-id="element-719" data-mp="bsqkrar88iqb">
                          <strong data-id="element-720" data-mp="btrzpqbd5pdb">
                            Less than 24 hours' notice or a "no-show":
                          </strong>{' '}
                          The full fee for the scheduled assessment may be
                          charged, as this time cannot be reallocated to other
                          clients.
                        </div>
                      </li>
                    </ul>
                  </div>}
              </div>
              {/* Court Attendance Section */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-721" data-mp="2dfxeg2nop8m4">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.court ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('court')} data-id="element-722" data-mp="2idyz2s0rdfzp">
                  <div className="flex items-center" data-id="element-723" data-mp="2wdgsxlswvjfx">
                    <AlertCircle className="h-5 w-5 mr-2" data-id="element-724" data-mp="2waukljy74zwn" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-725" data-mp="31b04uf24zk4p">
                      Court and Tribunal Attendance
                    </h2>
                  </div>
                  {openSections.court ? <ChevronUp className="h-5 w-5" data-id="element-726" data-mp="3a322y6oqgobt" /> : <ChevronDown className="h-5 w-5" data-id="element-727" data-mp="3f47vo4ie8blc" />}
                </button>
                {openSections.court && <div className="p-6 bg-white" data-id="element-728" data-mp="3k2symbp159dh">
                    <p className="text-slate-dark mb-4" data-id="element-729" data-mp="1jzqq2adahnnh">
                      The cancellation of court or tribunal attendance with
                      short notice can result in substantial costs and is
                      subject to separate terms.
                    </p>
                    <ul className="space-y-3 text-slate-dark" data-id="element-730" data-mp="1ozd3okx155wt">
                      <li className="flex items-start" data-id="element-731" data-mp="1oy1ycgnxrq3l">
                        <AlertCircle className="h-5 w-5 text-primary mr-2 mt-1" data-id="element-732" data-mp="22q8bdtvslgyt" />
                        <div data-id="element-733" data-mp="1ypg4366hdm56">
                          <strong data-id="element-734" data-mp="1yo4pscfesvzt">More than 7 working days' notice:</strong>{' '}
                          There will be no charge for the attendance fee. Any
                          preparation work already completed will be billed at
                          the Hourly Rate.
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-735" data-mp="id0pqvbz253n">
                        <AlertCircle className="h-5 w-5 text-primary mr-2 mt-1" data-id="element-736" data-mp="dcmp3ycp9xfn" />
                        <div data-id="element-737" data-mp="2oyn92g1lllgz">
                          <strong data-id="element-738" data-mp="2p0hvjysipln6">Less than 7 working days' notice:</strong> The
                          full fee for court attendance will be charged, in
                          addition to all preparation work, travel time, and
                          expenses.
                        </div>
                      </li>
                    </ul>
                  </div>}
              </div>
              {/* How to Cancel Section */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-739" data-mp="2b7s9juczogq2">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.howToCancel ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('howToCancel')} data-id="element-740" data-mp="2b5paylxrtf9q">
                  <div className="flex items-center" data-id="element-741" data-mp="3qpbv3igshf0y">
                    <Mail className="h-5 w-5 mr-2" data-id="element-742" data-mp="3vo59dd3wha26" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-743" data-mp="3vlj3dhwnr2m2">
                      How to Cancel
                    </h2>
                  </div>
                  {openSections.howToCancel ? <ChevronUp className="h-5 w-5" data-id="element-744" data-mp="2eha02tol68n8" /> : <ChevronDown className="h-5 w-5" data-id="element-745" data-mp="29mw16haptjdt" />}
                </button>
                {openSections.howToCancel && <div className="p-6 bg-white" data-id="element-746" data-mp="1zqas9kvkro4p">
                    <p className="text-slate-dark mb-4" data-id="element-747" data-mp="1zr2j6ie88xon">
                      All cancellations or requests to reschedule must be made
                      in writing via email to
                      enquiries@medicolegal-psychiatry.co.uk. The cancellation
                      will be deemed effective from the time and date of receipt
                      of the email.
                    </p>
                    <p className="text-slate-dark" data-id="element-748" data-mp="3l33vxwjwnqex">
                      We understand that unforeseen circumstances can arise and
                      will consider exceptions on a case-by-case basis.
                    </p>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}